import React, { useMemo } from 'react'
import { useState, useEffect } from 'react';
import '../viewFiles/common.scss';
import axios from 'axios';
import urls from '../../utils/url';
import {  isJson, getReadableDateOnly, getReadableTimeOnly , getReadableTime} from '../../utils/converter';
import Loading from '../common/loading';
import Reload from '../common/Reload';
import Cookie from 'js-cookie';
import NoData from '../common/NoData';
import '../navam/navamViewFile.scss';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import HighchartsHeatmap from "highcharts/modules/heatmap";


HighchartsHeatmap(Highcharts);

const NavamBillirubinComponent = (props) => {

    const cookie = Cookie.get('access_token')
    const { patientID } = props;
    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState(false);
    const [ activeText, setActiveText ] = useState('View Trend');
    const [ billirubinData, setBillirubinData] = useState([]) // To store billirubin data for new born
    const [graphBillirubinData, setGraphBillirubinData] = useState()
    const [category, setCategory] = useState();
    const [values, setValues] = useState();
    const [ graphWidth, setGraphWidth] = useState(800);
    const [firstTime, setFirstTime] = useState();
    const [lastTime, setLastTime] = useState();

    var chartMarginLeft = 70;
    var chartMarginRight = 40;
    var chartMarginTop = 60;
    var chartMarginBottom = 100;
    var itemMargin = 2;

    function getStep(){
      var width = window.screen.width;
      var step = 1 + parseInt((1280 - width));
      if(step < 1 ){
          step = 1;
      }
      return step;
    }


    useEffect(() => {
        setLoading(true)
        axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=labor_data&`,
          {
            headers: {
            'Request-ID': 'allow|me', 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${cookie}`
          }
          }).then((res) => {
            if(res.data){
              const json_data = isJson(res.data)
              const response =  json_data.response[0]
              
              const new_data = response.labor_data.map(obj => ({...obj, data_time: obj.data_time *= 1000 }))
              const sorted_data = new_data.sort((a, b) => (a.data_time > b.data_time) ? 1 : -1);

              const filteredBillirubinData = sorted_data.filter((value,index) => value.data_type === "bilirubin");

              const first_timestamp = filteredBillirubinData && filteredBillirubinData.length > 0 ? (filteredBillirubinData[0][0]) : null;
              setFirstTime(first_timestamp);

              const last_timestamp = filteredBillirubinData && filteredBillirubinData.length > 0 ? (filteredBillirubinData[filteredBillirubinData.length - 1][0]) : null;
              setLastTime(last_timestamp); 

              const graphData = filteredBillirubinData.map((item) => [
                getReadableTime(item.data_time), 
                parseFloat(item.param_1) 
              ]);


              const categories = graphData.map(item => item[0]); 
              const values = graphData.map(item => item[1]);

              // const minWidth = Math.max(800, categories.length * 150); // Adjust width dynamically

              setCategory(categories);
              setValues(values);

              setGraphBillirubinData(graphData)
              setBillirubinData(filteredBillirubinData)
              setLoading(false) 
              
            }
          }).catch((err) => {
            console.log("Error in Fetching Data",err)
            setError(true)
            setBillirubinData([])
            setLoading(false)
          }
        )
      },[])

    const handleToggle = () => {
      setActiveText((prev) => prev === 'View Trend' ? 'View Table' : 'View Trend');
    };

    const toggleText = activeText === 'View Trend' ? 'View Table' : 'View Trend';
    const toggleIcon = activeText === 'View Trend' ? '/view-table.svg' : '/view-trend.svg';

    const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
            e.preventDefault();
            alert('Please click on Download button to download the Partograph');
          }
    };

    useEffect(() => {
        const handleKeyDownEvent = (e) => {
          handleKeyDown(e);
        };
    
        window.addEventListener('keydown', handleKeyDownEvent);
    
        return () => {
          window.removeEventListener('keydown', handleKeyDownEvent);
        };
      }, []);


      useEffect (() => {
          Highcharts.setOptions({
            global: {
              useUTC: false
            }
          });
      },[])


    const billirubinGraph = useMemo(() => ({
      chart: {
        type: 'line',
        marginLeft: chartMarginLeft,
        marginRight: chartMarginRight,
        marginTop: chartMarginTop,
        marginBottom: chartMarginBottom,
        zoomType: 'x',
        scrollablePlotArea: {
          minWidth: category && category.length > 7 ? category.length * 100 : 900,
          scrollPositionX: -1,
        },
        borderRadius: 12,
        height: 500,
      },
    
      credits: { 
        enabled: false 
      },
    
      title: { 
        text: null 
      },
    
      xAxis: {
        type: 'category',
        categories: category,
        labels: {
          useHTML: true,
          formatter: function () {
            const label = this.value;
            
            // Split the label and check if it has at least 4 parts
            const parts = label.split(' ');
            
            // Ensure that there are at least 4 parts to avoid index errors
            if (parts.length >= 4) {
              const datePart = `${parts[0]} ${parts[1]} ${parts[2]}`;
              const timePart = `${parts[3]}`;
              
              return `
                <div style="text-align:center;">
                  ${datePart}<br/>
                  <span style="font-weight:normal;">${timePart}</span>
                </div>
              `;
            } else {
              // Return a fallback if the label doesn't have the expected format
              return `<div style="text-align:center;">${label}</div>`;
            }
          },
          rotation: 0,
          style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif',
          },
          //x:125,
        },
        tickInterval: 1,
        min: 0,
        gridZIndex: 1,
  
        scrollbar: {
          enabled: true,
        },
  
        title: {
          text: null,
        },
  
        gridLineColor: 'rgba(0, 0, 0, 0.1)',
        gridLineWidth: 1.1,
        gridLineDashStyle: 'Dash',
        lineColor: 'Black',
        lineWidth: 1,
      },
    
      yAxis: {
        title: { 
          text: 'Bilirubin (mg/dL)'
        },
        tickInterval: 5,
        gridLineColor: 'rgba(0, 0, 0, 0.1)',
        gridLineWidth: 1.1,
        gridLineDashStyle: 'Dash',
        lineColor: 'Black',
        lineWidth: 1,
        min: 0,
        max: 40,
        gridZIndex: 1,
      },

      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        itemMarginTop: itemMargin,
        itemMarginBottom: itemMargin,
        zIndex: 20,
        backgroundColor: '#FFFFFF',
        floating: true,
      },

      tooltip: {
        style: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '12px',
        },
        formatter: function () {
          return `
            <b>${this.x}</b><br/>
            <span style="color:${this.point.color}">\u25CF</span> 
            <b>Bilirubin Value:</b> ${this.y} mg/dL
          `;
        },
      },
      series: [
        {
          name: 'Bilirubin Value',
          data: values,
          lineWidth: 1.2,
          color: 'rgba(161, 99, 241, 1)',
          marker: {
            enabled: true,
            radius: 4,
          },
          // pointPlacement: 'between',
          // pointStart: 0,
        },
      ],
    
    }), [graphBillirubinData, category, values]);
    
    

  return (
    <>
    {
      loading ?
        <div className='loading-div'>
          <Loading/>
        </div> 
      : error ?
        <div className='reload-div'>
          <Reload/>
        </div>
      :

      <>

        <div className='info-section'>
            <div className = 'info-header'>
              <p className = 'heading'> Billirubin Value</p>
            </div>

            {activeText === 'View Table' ? 
                (
                    <>
                        {  
                            loading ? ( <div className='loading-div'><Loading/></div>)
                            : error ? ( <div className='reload-div'><Reload/></div>) 
                            : billirubinData && billirubinData.length > 0 ? 
                            (
                                <div style={{paddingBottom:`2rem`, marginBottom:`2rem`}}>
                                    
                                    <div className = 'header-container'>
                                        <p className = 'heading-text1'> Vital Table </p>
                                    </div>
                                    
                                    <table style={{ width: '80%', paddingLeft: '1rem', paddingRight: '1rem', marginLeft: '2.5rem', marginRight: '2rem', paddingBottom: '2rem', borderCollapse: 'collapse'}}>
                                        <thead>
                                            <tr className = "navam-table-layout navam-bilirubin-header" >
                                                <td className = "navam-header-text">Date</td>
                                                <td className = "navam-header-text">Time</td>
                                                <td className = "navam-header-text">Bilirubin Value (mg/dL)</td>
                                            </tr>
                                        </thead>

                                        <tbody style={{paddingBottom: '2rem'}}>
                                            {billirubinData.map((row, ind) => (
                                                <tr key={ind} className = "navam-table-layout" >
                                                <td className = "table-text ">{getReadableDateOnly(row.data_time) }</td>
                                                <td className = "table-text">{getReadableTimeOnly(row.data_time) }</td>
                                                <td className = "table-text">{row.param_1}</td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>
                            ) 
                            : 
                            <NoData/>
                        }
                    </>
                )
                :
                activeText === 'View Trend' ?
                (
                    <>
                        {/* //<BillirubinGraph firstTickPosition={firstTickPosition} graphBillirubinData={graphBillirubinData} tickPositions={tickPositions}/> */}
                      
                        {
                            graphBillirubinData && graphBillirubinData.length >= 2  ? 

                            (
                                <div style={{paddingBottom:`2rem`, marginBottom:`2rem`}}>
                                    
                                    <div className = 'header-container'>
                                        <p className = 'heading-text1'> Vital Graph </p>
                                    </div>

                                    <div className='graph-container'>

                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={billirubinGraph}
                                            constructorType={'chart'}
                                            allowChartUpdate={true}  
                                        /> 

                                    </div> 
                                </div>
                            )
                            : graphBillirubinData && graphBillirubinData.length < 2 ?
                              <p style={{display:`flex`, alignItems:`center`, justifyContent:`center`}}> No Trends available for less than 2 value </p>
                               : 
                              <NoData/>
                        }
        
                    </>
                )
                : <></>
            }
        </div>
        
        <div className = 'navam-toggle-button' onClick={ () => handleToggle()}>
          <img src={toggleIcon} alt='Toggle Icon' width={25} height={25}/>
          <p className='navam-toggle-button-text'>{toggleText}</p>
        </div>

      </>

     

    }
  </> 
  )
}

export default NavamBillirubinComponent 
